import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import AppBarPortal from '../components/AppBarPortal';
import AppLeftPortal from '../components/AppLeftPortal';
import AppFooterPortal from '../components/AppFooterPortal';

const styles = {
  pl: {
    paddingLeft: 25
  }
}

class PrivacyPolicy extends React.PureComponent {

  state = {
    title: 'POLÍTICA DE PRIVACIDAD'
  }

  componentDidMount() {
    document.body.classList.add("login");
    document.title = this.state.title + ' - CosmoCare';
  }

  componentWillUnmount() {
    document.body.classList.remove("login");
  }

  render() {
    const { classes } = this.props;

    return (
      <main style={{ display: 'block', padding: 25 }}>
        {!isMobile && <AppBarPortal />}
        {!isMobile && <AppLeftPortal />}
        {!isMobile && <AppFooterPortal />}
        
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='headline' align='center' paragraph>
              POLÍTICA DE PRIVACIDAD
            </Typography>
            <Typography paragraph variant="subheading">
              1. RESPONSABLE DEL TRATAMIENTO DE SUS DATOS PERSONALES
            </Typography>
            <Typography paragraph>
              Es compromiso de COSMOCARE EXPERT, SOCIEDAD LIMITADA, con NIF B67255455 y domicilio en 
              Calle Diputación, núm. 180, 6ª planta Oficinas B-C, 08011 Barcelona, (en adelante, COSMOCARE) el 
              respeto de la privacidad de los usuarios y la protección y seguridad de sus datos personales. Por 
              ello, se informa al usuario sobre la forma en que COSMOCARE recaba, trata y protege los datos de 
              carácter personal que le son facilitados a través de https://cosmocare.eu/, (en adelante, el “Sitio Web”)
            </Typography>
            <Typography paragraph>
              El usuario debe leer con atención esta política de privacidad y determinar libre y voluntariamente 
              si desea facilitar sus datos personales a COSMOCARE.
            </Typography>
            <Typography paragraph variant="subheading">
              2. INFORMACIÓN Y CONSENTIMIENTO 
            </Typography>
            <Typography paragraph>
              El usuario queda informado y presta su consentimiento libre, informado, específico e inequívoco para 
              que los datos personales que facilite a través del Sitio Web, así como los datos derivados de su navegación 
              y aquellos otros datos que pueda facilitar en un futuro, sean tratados por COSMOCARE de conformidad con 
              lo descrito en la presente política.
            </Typography>
            <Typography paragraph variant="subheading">
              3. OBLIGATORIEDAD DE FACILITAR DETERMINADOS DATOS 
            </Typography>
            <Typography paragraph>
              Los datos solicitados a través de las direcciones de correo electrónico dispuestas en el Sitio 
              Web (o mediante cualquier otro medio) son, con carácter general, obligatorios para cumplir con las 
              finalidades establecidas. Así, en caso de que el usuario no proporcione determinados datos (como identificativos o 
              de contacto) o los mismos no sean veraces, no nos será posible atender las solicitudes. 
            </Typography>
            <Typography paragraph>
              Además, el usuario:
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Garantiza que es mayor de edad y que los datos que facilita a COSMOCARE son verdaderos, exactos, completos 
              y actualizados. A estos efectos, el usuario responde de la veracidad de todos los datos que comunique y 
              mantendrá convenientemente actualizada la información facilitada, de tal forma que responda a su situación real.<br /> 
              - Garantiza que ha informado a los terceros de los que facilite sus datos, en caso de hacerlo, de los aspectos 
              contenidos en la presente política. Asimismo, garantiza que ha obtenido su autorización para facilitar sus datos 
              a COSMOCARE para los fines señalados.<br />
              - Será responsable de las informaciones falsas o inexactas que proporcione a través del Sitio Web y de los 
              daños y perjuicios, directos o indirectos, que ello cause a COSMOCARE o a terceros.
            </Typography>
            <Typography paragraph variant="subheading">
              4. FINALIDADES DEL TRATAMIENTO
            </Typography>
            <Typography paragraph>
              Los datos personales facilitados a través del Sitio Web serán tratados por COSMOCARE principalmente 
              para responder a las solicitudes que pueda efectuar y para cumplir con las finalidades descritas 
              a continuación: 
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Atender cuantas solicitudes pueda realizar el interesado y ofrecerle información sobre nuestros productos y 
              servicios. A través de correo electrónico (help@cosmocare.eu), formulario de contacto o mediante llamada telefónica.<br /> 
              - Inscribirse en los procesos de selección a través del envío de CV para poder trabajar con nosotros. Para ello, 
              el usuario debe enviar un correo presentando su candidatura junto a su CV en formato PDF a la 
              dirección contact@cosmocare.eu. <br />
              - Inscribirse en programas de pruebas de evaluación de la aceptabilidad de productos cosméticos en 
              calidad de voluntarios y/o consumidores.<br />
              - Remitir comunicaciones comerciales o informativas con novedades sobre nuestros programas de desarrollo, 
              en caso de que el usuario preste su consentimiento para ello. En su caso, el correo oportuno para 
              remitirle información sobre nuestros productos es el siguiente: contact@cosmocare.eu
            </Typography>
            <Typography paragraph variant="subheading">
              5. TIPOLOGÍA DE DATOS
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Datos identificativos: nombre, apellidos. 
              - Datos académicos y profesionales: como el CV o la pertenencia a asociaciones profesionales.<br />
              - Datos relativos a las características personales: sexo, nacionalidad, características físicas y antropométricas, 
              fecha y lugar de nacimiento.<br />
              - Datos de contacto: dirección de correo electrónico, número de teléfono, dirección postal.<br />
              - Datos de navegación: los mínimos imprescindibles para posibilitar el funcionamiento del Sitio Web.
            </Typography>
            <Typography paragraph>
              En caso de que el usuario facilite datos de terceros, manifiesta contar con el consentimiento de 
              los mismos y se compromete a trasladarle la información contenida en esta Política de Privacidad, 
              eximiendo a COSMOCARE de cualquier responsabilidad en este sentido. No obstante, COSMOCARE podrá 
              llevar a cabo verificaciones periódicas para constatar este hecho, adoptando las medidas de diligencia 
              debida que correspondan.
            </Typography>
            <Typography paragraph variant="subheading">
              6. BASES DE LEGITIMACIÓN
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Para la selección de empleados, será el consentimiento prestado por el candidato, a través del envío de su solicitud.<br /> 
              - Para tratar los datos de navegación, el consentimiento del usuario.<br />
              - Para la gestión de consultas, solicitudes de información, quejas y/o reclamaciones, el consentimiento prestado por el usuario para ello.<br />
              - Para la inscripción en programas de pruebas de evaluación de la aceptabilidad de productos cosméticos, el consentimiento del usuario.<br />
              - Para la realización, en su caso, de informes estadísticos anónimos, el interés legítimo de COSMOCARE.<br />
            </Typography>
            <Typography paragraph variant="subheading">
              7. DESTINATARIOS
            </Typography>
            <Typography paragraph>
              Los datos del usuario podrán ser comunicados a:
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Nuestros proveedores de servicios, necesarios para cumplir con las finalidades anteriormente descritas y prestarle los servicios 
              solicitados. Dichos proveedores no tratarán sus datos para finalidades propias que no hayan sido previamente informadas 
              por COSMOCARE.<br/>
              - Agencia Española de Medicamentos y Productos Sanitarios, para el cumplimiento de las obligaciones legales, 
              incluyendo las notificaciones de eventos adversos.
            </Typography>
            <Typography paragraph variant="subheading">
              8. TRANSFERENCIAS INTERNACIONALES DE DATOS
            </Typography>
            <Typography paragraph>
              Le informamos que sus datos pueden ser transferidos a nuestros proveedores de servicios ubicados en terceros 
              países fuera del Espacio Económico Europeo, únicamente para cumplir con las finalidades descritas y prestarles 
              los servicios solicitados.
            </Typography>
            <Typography paragraph>
              En todo caso, le confirmamos que cualquier transferencia de sus datos contará con todas las garantías para 
              mantener la confidencialidad y seguridad de los mismos.
            </Typography>
            <Typography paragraph variant="subheading">
              9. PLAZOS DE CONSERVACIÓN
            </Typography>
            <Typography paragraph>
              Los datos serán tratados durante el tiempo necesario para la realización de las finalidades para las que fueron 
              recogidos, salvo que el usuario solicite su baja a COSMOCARE, se oponga o revoque su consentimiento. 
            </Typography>
            <Typography paragraph>
              En el supuesto de selección de personal, sus datos curriculares serán conservados durante un plazo de 24 meses.
            </Typography>
            <Typography paragraph>
              El resto de datos derivados de las demás finalidades, se conservarán un máximo de 5 años, a contar desde el 
              momento en el que sean facilitados, a los meros efectos de poder atender requerimientos y/o atender reclamaciones. 
            </Typography>
            <Typography paragraph variant="subheading">
              10. EJERCICIO DE DERECHOS
            </Typography>
            <Typography paragraph>
              El usuario puede enviar un escrito a COSMOCARE para ejercitar sus derechos en cualquier momento, 
              de manera gratuita, adjuntando fotocopia de documento que acredite su identidad, con la referencia 
              “Protección de Datos”, a través de los siguientes medios:
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Correo postal: Calle Diputación, núm. 180, 6ª planta Oficinas B-C, 08011 Barcelona.<br />
              - Correo electrónico: contact@cosmocare.eu<br />  
            </Typography>
            <Typography paragraph>
              El usuario queda informado de que tiene la posibilidad de ejercer los siguientes derechos:
            </Typography>
            <Typography paragraph className={classes.pl}>
              - Revocar los consentimientos otorgados. <br />
              - Obtener confirmación acerca de si en COSMOCARE se están tratando datos personales que conciernen al usuario o no. <br />
              - Acceder a sus datos personales. <br />
              - Rectificar los datos inexactos o incompletos. <br />
              - Solicitar la supresión de sus datos cuando, entre otros motivos, los datos ya no sean necesarios para los fines que fueron recogidos. <br />
              - Obtener de COSMOCARE la limitación del tratamiento de los datos cuando se cumpla alguna de las condiciones previstas 
              en la normativa de protección de datos.<br /> 
              - Solicitar la portabilidad de los datos facilitados por el usuario en aquellos casos previstos en la normativa.<br /> 
              - Interponer una reclamación relativa a la protección de sus datos personales ante la Agencia Española de Protección 
              de Datos en la dirección Calle de Jorge Juan, 6, 28001 Madrid, cuando el usuario considere que COSMOCARE ha 
              vulnerado los derechos que le son reconocidos por la normativa aplicable en protección de datos.
            </Typography>
            <Typography paragraph variant="subheading">
              11. MEDIDAS DE SEGURIDAD
            </Typography>
            <Typography paragraph>
              Por último, nos complace informarle de que trataremos sus datos en todo momento de forma absolutamente confidencial y 
              guardando el preceptivo deber de secreto respecto de los mismos, de conformidad con lo previsto en la normativa 
              de aplicación, adoptando al efecto las medidas de índole técnica y organizativas necesarias que garanticen la 
              seguridad de sus datos y eviten su alteración, pérdida, tratamiento o acceso no autorizado, habida cuenta del 
              estado de la tecnología, la naturaleza de los datos almacenados y los riesgos a que están expuestos.
            </Typography>
            <Typography paragraph align="right">
              Última actualización: <strong>agosto de 2018</strong>
            </Typography>
          </Grid>
        </Grid>

      </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles)(PrivacyPolicy)
  )
);


// WEBPACK FOOTER //
// ./src/modules/shared/pages/PrivacyPolicy.js